import { ConnectedAccount } from 'types/stripe';
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type StripeStore = {
  isAccountEnabled: boolean;
  isDetailsSubmitted: boolean;
  account: ConnectedAccount | null;
  isFetchingData?: boolean;
};

const useStripeStore = create(
  immer<StripeStore>(() => ({
    account: null,
    isAccountEnabled: false,
    isDetailsSubmitted: false,
    isFetchingData: true,
  })),
);

const checkIfDetaialsSubmitted = (c: ConnectedAccount) => {
  if (c?.details_submitted) {
    return true;
  } else if (c?.tos_acceptance) {
    if ('date' in c?.tos_acceptance && c?.tos_acceptance?.date !== null) {
      return true;
    }
  } else {
    return false;
  }

  return false;
};

const actions = {
  setFetchingDataStatus: (_isFetchingData: boolean) => {
    const set = useStripeStore.setState;
    set((state) => {
      state.isFetchingData = _isFetchingData;
    });
  },
  setAccountData: (_account: ConnectedAccount) => {
    const set = useStripeStore.setState;

    const _isAccountEnabled = Boolean(_account?.charges_enabled);
    const _isDetailsSubmitted = checkIfDetaialsSubmitted(_account);

    set((state) => {
      state.account = _account;

      if (_isAccountEnabled) {
        state.isAccountEnabled = true;
      }

      if (_isDetailsSubmitted) {
        state.isDetailsSubmitted = true;
      }
    });
  },
  reset: () => {
    const setState = useStripeStore.setState;
    setState((state) => ({
      account: null,
      isAccountEnabled: false,
      isDetailsSubmitted: false,
      isFetchingData: true,
    }));
  },
};

const selectors = {
  useAccount: () => useStripeStore((state) => state.account),
  useIsAccountEnabled: () => useStripeStore((state) => state.isAccountEnabled),
  useIsDetailsSubmitted: () =>
    useStripeStore((state) => state.isDetailsSubmitted),
  useIsFetchingData: () => useStripeStore((state) => state.isFetchingData),
};

/**
 * **Stripe Store**
 *
 * this store is used to store stripe connect data
 *
 * **"$"** is a convention to indicate that this is a store
 */
const $stripe = {
  actions,
  selectors,
};

export default $stripe;
